export default __webpack_public_path__ + "static/banner-bg-e017e53a882d3069f9d6e1abab284a97.jpg";